import { render } from "./ScheduledSMS.vue?vue&type=template&id=7f6cf064&scoped=true"
import script from "./ScheduledSMS.vue?vue&type=script&lang=js"
export * from "./ScheduledSMS.vue?vue&type=script&lang=js"

import "./ScheduledSMS.vue?vue&type=style&index=0&id=7f6cf064&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f6cf064"]])

export default __exports__